import React, { PureComponent } from 'react';
import * as S from './PlaylistLinks.styles';

export default class PlaylistLinks extends PureComponent {
  render() {
    return (
      <S.PlaylistLinks>
        <a
          data-testid="PlaylistLink-GooglePlay"
          href="https://play.google.com/store/apps/details?id=cz.lagardere.android.youradio.news&referrer=utm_source%3Dwidget%26utm_medium%3Dwidget"
          target="_blank"
          rel="noopener noreferrer"
        >
          <S.GooglePlayImage />
        </a>

        <a
          data-testid="PlaylistLink-AppStore"
          href="https://itunes.apple.com/us/app/youradio-talk-mluven%C3%A9-slovo/id1234520254?ls=1&mt=8"
          target="_blank"
          rel="noopener noreferrer"
        >
          <S.AppStoreImage />
        </a>
      </S.PlaylistLinks>
    );
  }
}
